var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareerNavigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.711,
    height: 36.711,
    viewBox: "0 0 36.711 36.711",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "compass-icon_1_",
    "data-name": "compass-icon (1)",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52743",
    "data-name": "Path 52743",
    d: "M19.356,1A18.356,18.356,0,1,0,37.711,19.356,18.362,18.362,0,0,0,19.356,1M28.9,11.01,24.287,22.195a3.741,3.741,0,0,1-2.093,2.093L11.01,28.9a.919.919,0,0,1-1.2-1.2l4.613-11.185a3.741,3.741,0,0,1,2.093-2.093L27.7,9.811a.919.919,0,0,1,1.2,1.2",
    transform: "translate(0 0)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5205",
    "data-name": "Ellipse 5205",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(17 16.711)",
    fill: "#3db6fb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerNavigation);
export default __webpack_public_path__ + "static/media/Career Navigation.b212808246a078c8d8b5e1fa63ea22b5.svg";
export { ForwardRef as ReactComponent };